import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import { Multiselect } from "multiselect-react-dropdown"
import ReactExport from "react-data-export"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
            marginTop: "15px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
            padding: " 10px",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeKindsenddamagefile extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.multiselectCompanyRef = React.createRef()
            this.multiselectFieldinsuranceRef = React.createRef()
            this.multiselectSenddamagefileKindRef = React.createRef()
            this.multiselectStateRef = React.createRef()
            this.multiselectCityRef = React.createRef()

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  damagefileinfos: [],
                  expertInfofilter: [],
                  rowsPerPage: 5,
                  page: 0,
                  kindsenddamagefile_id: "",
                  expert_code: "",
                  expert_name: "",
                  expert_family: "",
                  expert_mobile: "",
                  expert_tell: "",
                  expert_evaluatorco_name: "",
                  expert_city_name: "",
                  expert_evaluatorco_logo_url: "",
                  fielddamagefile_name: "",
                  fielddamagefile_logo_url: "",
                  orderBy: "kindsenddamagefile_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newKindsenddamagefile: true,

                  optionAgent: [],
                  selectedAgent: "",

                  optionCompany: [],
                  optionFilterCompany: "",
                  selectedCompany: [{ value: "0", label: "" }],

                  optionFieldinsurance: [{ value: "0", label: "همه رشته ها" }],
                  optionFilterFieldinsurance: "",
                  selectedFieldinsurance: { value: "0", label: "همه رشته ها" },

                  optionSenddamagefileKind: [],
                  optionFilterSenddamagefileKind: "",
                  selectedSenddamagefileKind: "",

                  optionState: [{ value: "0", label: "همه استانها" }],
                  selectedState: { value: "0", label: "همه استانها" },
                  optionCity: [{ value: "0", label: "همه شهرها" }],
                  optionFilterCity: [],
                  selectedCity: { value: "0", label: "همه شهرها" },

                  selectedFilterCompany: [],
                  selectedFilterSenddamagefileKind: [],
                  selectedFilterFieldinsurance: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  selectedFilterDeactive: "",
            }
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            console.log(row2.kindsenddamagefile_expert_id)
            this.setState(
                  {
                        kindsenddamagefile_id: row2.kindsenddamagefile_id,
                        newKindsenddamagefile: false,
                        selectedCompany: { value: row2.evaluatorco_id, label: row2.expert_evaluatorco_name, logo: row2.expert_evaluatorco_logo_url },
                        selectedFieldinsurance: {
                              value: row2.kindsenddamagefile_fielddamagefile_id,
                              label: row2.fielddamagefile_name,
                              logo: row2.fielddamagefile_logo_url,
                        },
                        selectedSenddamagefileKind: { value: row2.kindsenddamagefile_kind_id, label: row2.senddamagefile_kind_name },
                        selectedState: { value: row2.kindsenddamagefile_state_id, label: row2.expert_state_name },
                        selectedCity: { value: row2.kindsenddamagefile_city_id, label: row2.expert_city_name },
                        selectedAgent: {
                              value: row2.kindsenddamagefile_expert_id,
                              label: row2.expert_name + " " + row2.expert_family + "-" + row2.expert_mobile,
                              expert_status: row2.expert_status,
                              evaluatorco_id: row2.evaluatorco_id,
                        },
                  },
                  () => {
                        this.getoptionCityID()
                  }
            )
      }

      newKindsenddamagefileFunc = (event) => {
            this.setState({
                  kindsenddamagefile_id: "",
                  newKindsenddamagefile: true,
                  selectedCompany: [{ value: "0", label: "" }],
                  selectedFieldinsurance: [{ value: "0", label: "همه شرکت ها" }],
                  selectedSenddamagefileKind: {},
                  selectedState: { value: "0", label: "همه استانها" },
                  selectedCity: { value: "0", label: "همه شهرها" },
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getKindsenddamagefile()
                                    self.getoptionStateID()
                                    self.getoptionCompany()
                                    self.getoptionFieldinsurance()
                                    self.getoptionSenddamagefileKind()
                                    self.getoptionAgent()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getKindsenddamagefile() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ damagefileinfos: arr.data, expertInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        } else if (arr.result === "eror") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_kindsenddamagefile")

            xhttp.open("POST", `${constants.BASE_URL}/kindsenddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].evaluatorco_id,
                                          label: arr.data[k].evaluatorco_name,
                                          logo: arr.data[k].evaluatorco_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_evaluatorco")
            xhttp.open("POST", `${constants.BASE_URL}/evaluatorco`)
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Fieldinsurance = [{ value: "0", label: "همه رشته ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Fieldinsurance.push({
                                          value: arr.data[k].fielddamagefile_id,
                                          label: arr.data[k].fielddamagefile_fa,
                                          logo: arr.data[k].fielddamagefile_logo_url,
                                    })
                              }
                              self.setState({ optionFieldinsurance: Fieldinsurance }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fielddamagefile")
            xhttp.open("POST", `${constants.BASE_URL}/fielddamagefile`)
            xhttp.send(fd)
      }

      getoptionAgent = () => {
            const { selectedCompany } = this.state
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({
                                          value: arr.data[k].expert_id,
                                          label: arr.data[k].expert_name + " " + arr.data[k].expert_family + "-" + arr.data[k].expert_mobile,
                                          expert_status: arr.data[k].expert_status,
                                          evaluatorco_id: arr.data[k].evaluatorco_id,
                                    })
                              }
                              self.setState({ optionAgent: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_expert")
            if (selectedCompany.value !== "0") {
                  fd.append("expert_evaluatorco_id", selectedCompany.value)
            } //

            xhttp.open("POST", `${constants.BASE_URL}/expert`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionSenddamagefileKind = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var SenddamagefileKind = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    SenddamagefileKind.push({ value: arr.data[k].senddamagefile_kind_id, label: arr.data[k].senddamagefile_kind_name })
                              }
                              self.setState({ optionSenddamagefileKind: SenddamagefileKind, selectedSenddamagefileKind: SenddamagefileKind[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_senddamagefile_kind")

            xhttp.open("POST", `${constants.BASE_URL}/kindsenddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionStateID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه استانها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].state_id, label: arr.data[k].state_name })
                              }
                              self.setState({ optionState: State }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_state")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getoptionCityID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه شهر ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", this.state.selectedState.value)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      saveNewKindsenddamagefile = () => {
            const { selectedCompany, selectedFieldinsurance, selectedSenddamagefileKind, selectedState, selectedCity, selectedAgent } = this.state

            if (
                  selectedFieldinsurance.value == null ||
                  selectedCompany.value == null ||
                  selectedState.value == null ||
                  selectedCity.value == null ||
                  selectedAgent.value == null
            ) {
                  this.setState({ snackstr: "لطفا پارامتر های فرم را کامل نمایید", showSnack: true, snackMode: "error" })
            } else {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getKindsenddamagefile()
                                    self.newKindsenddamagefileFunc()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_kindsenddamagefile")

                  fd.append("kindsenddamagefile_evaluatorco_id", selectedCompany.value)
                  fd.append("kindsenddamagefile_fielddamagefile_id", selectedFieldinsurance.value)
                  fd.append("kindsenddamagefile_kind_id", selectedSenddamagefileKind.value)
                  fd.append("kindsenddamagefile_state_id", selectedState.value)
                  fd.append("kindsenddamagefile_city_id", selectedCity.value)
                  fd.append("kindsenddamagefile_expert_id", selectedAgent.value)

                  xhttp.open("POST", `${constants.BASE_URL}/kindsenddamagefile`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            }
      }

      changeKindsenddamagefile = () => {
            const {
                  kindsenddamagefile_id,
                  selectedCompany,
                  selectedFieldinsurance,
                  selectedSenddamagefileKind,
                  selectedState,
                  selectedCity,
                  selectedAgent,
            } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getKindsenddamagefile()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_kindsenddamagefile")
            fd.append("kindsenddamagefile_id", kindsenddamagefile_id)
            fd.append("kindsenddamagefile_evaluatorco_id", selectedCompany.value)
            console.log(selectedCompany)
            fd.append("kindsenddamagefile_fielddamagefile_id", selectedFieldinsurance.value)

            fd.append("kindsenddamagefile_kind_id", selectedSenddamagefileKind.value)
            fd.append("kindsenddamagefile_state_id", selectedState.value)
            fd.append("kindsenddamagefile_city_id", selectedCity.value)
            fd.append("kindsenddamagefile_expert_id", selectedAgent.value)

            xhttp.open("POST", `${constants.BASE_URL}/kindsenddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deletKindsenddamagefile = () => {
            const { kindsenddamagefile_id } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getKindsenddamagefile()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_kindsenddamagefile")
            fd.append("kindsenddamagefile_id", kindsenddamagefile_id)

            xhttp.open("POST", `${constants.BASE_URL}/kindsenddamagefile`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.expertInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleAgent = (selectedAgent) => {
            this.setState({ selectedAgent: selectedAgent })
      }
      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      handleState = (selectedState) => {
            this.setState({ selectedState: selectedState, selectedCity: { value: "0", label: "همه شهرها" } }, () => {
                  this.getoptionCityID()
            })
      }

      handleCity = (selectedCity) => {
            this.setState({ selectedCity: selectedCity }, () => {})
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.getoptionAgent()
            })
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance }, () => {})
      }

      handleSenddamagefileKind = (selectedSenddamagefileKind) => {
            this.setState({ selectedSenddamagefileKind: selectedSenddamagefileKind })
      }
      onSelectOptionSenddamagefileKind = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterSenddamagefileKind: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionSenddamagefileKind = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterSenddamagefileKind: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionFieldinsurance = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterFieldinsurance: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionFieldinsurance = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterFieldinsurance: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionCity = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCity = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }
      onSelectOptionState = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }

      onRemoveOptionState = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }
      getOptionFilterCity = () => {
            const { selectedFilterState, optionState } = this.state
            this.setState({ optionFilterCity: [] }, () => {
                  for (var i = 0; i < selectedFilterState.length; i++) {
                        this.getCity(selectedFilterState[i].value)
                  }
            })
      }

      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionFilterCity.length > 0) {
                                    var State = self.state.optionFilterCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionFilterCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      filterFunc = () => {
            const {
                  damagefileinfos,
                  expertInfofilter,
                  selectedFilterState,
                  selectedFilterCity,
                  selectedFilterCompany,
                  selectedFilterFieldinsurance,
                  selectedFilterSenddamagefileKind,
            } = this.state
            var i, j, temparray2, temparray, b1, b2, b3, b4, b5
            temparray = damagefileinfos
            temparray2 = []
            for (i = 0; i < damagefileinfos.length; i++) {
                  b1 = false
                  b2 = false
                  b3 = false
                  b4 = false

                  if (selectedFilterState.length === 0) {
                        b1 = true
                  } else {
                        for (j = 0; j < selectedFilterState.length; j++) {
                              if (temparray[i].kindsenddamagefile_state_id === selectedFilterState[j].value) {
                                    b1 = true
                              }
                        }
                  }
                  if (selectedFilterCity.length === 0) {
                        b2 = true
                  } else {
                        for (j = 0; j < selectedFilterCity.length; j++) {
                              if (temparray[i].kindsenddamagefile_city_id === selectedFilterCity[j].value) {
                                    b2 = true
                              }
                        }
                  }
                  if (selectedFilterCompany.length === 0) {
                        b3 = true
                  } else {
                        for (j = 0; j < selectedFilterCompany.length; j++) {
                              if (temparray[i].kindsenddamagefile_evaluatorco_id === selectedFilterCompany[j].value) {
                                    b3 = true
                              }
                        }
                  }

                  if (selectedFilterFieldinsurance.length === 0) {
                        b5 = true
                  } else {
                        for (j = 0; j < selectedFilterFieldinsurance.length; j++) {
                              if (temparray[i].kindsenddamagefile_fielddamagefile_id === selectedFilterFieldinsurance[j].value) {
                                    b5 = true
                              }
                        }
                  }

                  if (selectedFilterSenddamagefileKind.length === 0) {
                        b4 = true
                  } else {
                        for (j = 0; j < selectedFilterSenddamagefileKind.length; j++) {
                              if (temparray[i].kindsenddamagefile_kind_id === selectedFilterSenddamagefileKind[j].value) {
                                    b4 = true
                              }
                        }
                  }

                  if (b1 && b2 && b3 && b4 && b5) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ expertInfofilter: temparray2 }, () => {})
      }
      ClearFilter = () => {
            this.setState({
                  selectedFilterCompany: [],
                  selectedFilterFieldinsurance: [],
                  selectedFilterSenddamagefileKind: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  optionFilterCity: [],
                  selectedOptionCity: [],
                  selectedOptionState: [],
                  expertInfofilter: this.state.damagefileinfos,
            })
            this.multiselectCompanyRef.current.resetSelectedValues()
            this.multiselectFieldinsuranceRef.current.resetSelectedValues()
            this.multiselectSenddamagefileKindRef.current.resetSelectedValues()
            this.multiselectStateRef.current.resetSelectedValues()
            this.multiselectCityRef.current.resetSelectedValues()
      }

      render() {
            const { classes } = this.props
            const {
                  selectedAgent,
                  optionAgent,
                  optionCity,
                  optionFilterCity,
                  selectedCity,
                  optionCompany,
                  selectedCompany,
                  optionFieldinsurance,
                  selectedFieldinsurance,
                  optionSenddamagefileKind,
                  selectedSenddamagefileKind,
                  optionState,
                  selectedState,
                  snackMode,
                  snackstr,
                  showSnack,
                  newKindsenddamagefile,
                  kindsenddamagefile_id,
                  expert_evaluatorco_logo_url,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  expertInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی روش توزیع : " + kindsenddamagefile_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">استان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"استان"}
                                                                              value={selectedState}
                                                                              onChange={this.handleState}
                                                                              options={optionState}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شهر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شهر"}
                                                                              value={selectedCity}
                                                                              onChange={this.handleCity}
                                                                              options={optionCity}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">شرکت ارزیاب خسارت</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت ارزیاب خسارت"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="Remy Sharp" style={{ width: "25%" }} src={selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">فیلد خسارت درمان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"فیلد خسارت درمان"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleFieldinsurance}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt="Remy Sharp"
                                                                              style={{ width: "25%" }}
                                                                              src={selectedFieldinsurance.logo}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع توزیع </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={" نوع توزیع"}
                                                                              value={selectedSenddamagefileKind}
                                                                              onChange={this.handleSenddamagefileKind}
                                                                              options={optionSenddamagefileKind}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">کارشناس خسارت</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کارشناس خسارت"}
                                                                              value={selectedAgent}
                                                                              onChange={this.handleAgent}
                                                                              options={optionAgent}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  {newKindsenddamagefile ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.saveNewKindsenddamagefile()
                                                                              }}
                                                                        >
                                                                              {"ثبت روش توزیع جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newKindsenddamagefileFunc}
                                                                              >
                                                                                    {"روش توزیع جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.changeKindsenddamagefile()
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deletKindsenddamagefile()
                                                                                    }}
                                                                              >
                                                                                    {"حذف روش"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionCompany} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                              ref={this.multiselectCompanyRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="شرکت ارزیاب خسارت"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionFieldinsurance} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionFieldinsurance} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionFieldinsurance} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionFieldinsurance} // Function will trigger on remove event
                                                                              ref={this.multiselectFieldinsuranceRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="فیلد خسارت درمان"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionSenddamagefileKind} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionSenddamagefileKind} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionSenddamagefileKind} // Function will trigger on remove event
                                                                              ref={this.multiselectSenddamagefileKindRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="نوع توزیع"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionState} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionState} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                                                                              ref={this.multiselectStateRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="استان ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionFilterCity} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionCity} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCity} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                                                                              ref={this.multiselectCityRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="شهر ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Button variant="outlined" color="primary" onClick={this.filterFunc}>
                                                                        {"جستجو "}
                                                                  </Button>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <Button variant="outlined" color="primary" onClick={this.ClearFilter}>
                                                                        {"پاک کردن فیلتر ها "}
                                                                  </Button>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell>
                                                                                    <ExcelFile
                                                                                          element={
                                                                                                <Button variant="outlined" color="primary">
                                                                                                      {" "}
                                                                                                      {"اکسل "}
                                                                                                </Button>
                                                                                          }
                                                                                    >
                                                                                          <ExcelSheet data={expertInfofilter} name="نمایندگان">
                                                                                                <ExcelColumn
                                                                                                      label="آی دی"
                                                                                                      value="kindsenddamagefile_id"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="استان "
                                                                                                      value="expert_state_name"
                                                                                                />
                                                                                                <ExcelColumn label="شهر " value="expert_city_name" />
                                                                                                <ExcelColumn
                                                                                                      label="شرکت ارزیاب خسارت"
                                                                                                      value="expert_evaluatorco_name"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="فیلد خسارت درمان"
                                                                                                      value="fielddamagefile_name"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="نوع توزیع"
                                                                                                      value="senddamagefile_kind_name"
                                                                                                />
                                                                                                <ExcelColumn label="جنسیت" value="expert_gender" />
                                                                                                <ExcelColumn label="نام" value="expert_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام خانوادگی"
                                                                                                      value="expert_family"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره همراه"
                                                                                                      value="expert_mobile"
                                                                                                />
                                                                                                <ExcelColumn label="کد نمایندگی" value="expert_code" />
                                                                                          </ExcelSheet>
                                                                                    </ExcelFile>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"استان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_state_name"}
                                                                                          direction={orderBy === "expert_state_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_city_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شهر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_city_name"}
                                                                                          direction={orderBy === "expert_city_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_city_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"expert_evaluatorco_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت ارزیاب خسارت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_evaluatorco_name"}
                                                                                          direction={orderBy === "expert_evaluatorco_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_evaluatorco_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fielddamagefile_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"فیلد خسارت درمان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fielddamagefile_name"}
                                                                                          direction={
                                                                                                orderBy === "fielddamagefile_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fielddamagefile_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"kindsenddamagefile_kind_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "kindsenddamagefile_kind_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {"نوع ارجاع"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "kindsenddamagefile_kind_id"}
                                                                                          direction={
                                                                                                orderBy === "kindsenddamagefile_kind_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("kindsenddamagefile_kind_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"expert_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام و نام خانوادگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_name"}
                                                                                          direction={orderBy === "expert_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_mobile"}
                                                                                          direction={orderBy === "expert_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {expertInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["kindsenddamagefile_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"kindsenddamagefile_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["kindsenddamagefile_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_state_name"} align={"center"}>
                                                                                                      {row["expert_state_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_city_name"} align={"center"}>
                                                                                                      {row["expert_city_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"expert_evaluatorco_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["expert_evaluatorco_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fielddamagefile_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fielddamagefile_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"senddamagefile_kind_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["senddamagefile_kind_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_name"} align={"center"}>
                                                                                                      {row["expert_name"] + " " + row["expert_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_mobile"} align={"center"}>
                                                                                                      {row["expert_mobile"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                                            component="div"
                                                            count={expertInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeKindsenddamagefile)
